import { useFormikContext } from 'formik';
import { useCheckFormikError } from '@/hooks/formik/useCheckFormikError';
import { Dropdown, DropdownProps } from '@/components/dropdown';
import { cn } from '@/lib/utils';

export const FormDropdown = ({
  name = '',
  disabled = false,
  className = '',
  ...props
}: DropdownProps) => {
  const { isSubmitting } = useFormikContext();
  const { error } = useCheckFormikError({ name });
  const variant = error ? 'error' : 'default';
  return (
    <Dropdown
      name={name}
      variant={variant}
      disabled={isSubmitting || disabled}
      className={cn('max-w-form', className)}
      data-testid={`form-dropdown-${name}`}
      {...props}
    />
  );
};
